(function () {
  'use strict';

  const root = document.getElementById('spanish-kitchen-guide');

  if (!root) {
    return;
  }

  const guide = window.GUIDE;

  if (
    !guide ||
    !Array.isArray(guide.slides) ||
    !guide.slides.length
  ) {
    console.warn('Spanish Kitchen Guide: GUIDE configuration not found.');
    return;
  }

  /* ========================================================
     SETTINGS
  ======================================================== */

  const settings = Object.assign(
    {
      autoplay: true,
      autoplayDelay: 8000,
      resumeDelay: 10000,
      loop: true,
      mobileBreakpoint: 900
    },
    guide.settings || {}
  );

  let currentIndex = 0;
  let autoplayTimer = null;
  let resumeTimer = null;
  let isPaused = !settings.autoplay;
  let cleanMode = false;
  let lastFocusedElement = null;

  /* ========================================================
     HELPERS
  ======================================================== */

  function escapeHtml(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function padNumber(number) {
    return String(number).padStart(2, '0');
  }

  function getSlideImage(slide) {
    if (!slide || !slide.image) {
      return {
        desktop: '',
        mobile: '',
        alt: ''
      };
    }

    return {
      desktop: slide.image.desktop || '',
      mobile: slide.image.mobile || slide.image.desktop || '',
      alt: slide.image.alt || guide.title || ''
    };
  }

  function clockIcon() {
    return `
      <svg
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
      >
        <circle
          cx="16"
          cy="16"
          r="11"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
        ></circle>

        <path
          d="M16 9.5V16L20.7 18.8"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>

        <path
          d="M12.8 3.8H19.2"
          fill="none"
          stroke="currentColor"
          stroke-width="1.7"
          stroke-linecap="round"
        ></path>
      </svg>
    `;
  }

  function getShopRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getItemData(item) {
    if (!item) {
      return null;
    }

    const descriptionNode = item.querySelector(
      '.skgc-product-bridge-description'
    );

    return {
      group: item.dataset.skgcGroup || '',
      productId: item.dataset.productId || '',
      variantId: item.dataset.variantId || '',
      title: item.dataset.productTitle || '',
      url: item.dataset.productUrl || '#',
      available: item.dataset.productAvailable === 'true',
      price: item.dataset.productPrice || '',
      priceFormatted: item.dataset.productPriceFormatted || '',
      comparePrice: item.dataset.productComparePrice || '',
      comparePriceFormatted:
        item.dataset.productComparePriceFormatted || '',
      image: item.dataset.productImage || '',
      description:
        descriptionNode
          ? descriptionNode.textContent.trim()
          : ''
    };
  }

  function setTemporaryButtonText(
    button,
    temporaryText,
    originalText,
    delay
  ) {
    if (!button) {
      return;
    }

    button.textContent = temporaryText;

    window.setTimeout(function () {
      button.textContent = originalText;
    }, delay || 1800);
  }

  /* ========================================================
     CONFIG
  ======================================================== */

  const recipeGuideConfig = guide.recipeGuide || {};
  const attributionConfig = guide.attribution || {};
  const shareConfig = guide.share || {};
  const shopConfig = guide.shop || {};

  /* ========================================================
     MAIN HTML
  ======================================================== */

  root.classList.add('skgc');

  root.innerHTML = `

    <div class="skgc__shell">

      <div class="skgc__stage"></div>

      <header class="skgc__topbar">

        <div class="skgc__brand">
          <strong>La despensa</strong>
          <span>Spanish Kitchen</span>
        </div>

        <div class="skgc__meta">

          ${
            guide.time
              ? `<span>${escapeHtml(guide.time)}</span>`
              : ''
          }

          ${
            guide.servings
              ? `<span>${escapeHtml(guide.servings)}</span>`
              : ''
          }

          ${
            guide.difficulty
              ? `<span>${escapeHtml(guide.difficulty)}</span>`
              : ''
          }

        </div>

        <button
          class="skgc__mode"
          type="button"
          aria-label="Hide text and view image"
        >
          View image
        </button>

      </header>

      <button
        class="skgc__nav skgc__nav--prev"
        type="button"
        aria-label="Previous slide"
      >
        ‹
      </button>

      <button
        class="skgc__nav skgc__nav--next"
        type="button"
        aria-label="Next slide"
      >
        ›
      </button>

      <div
        class="skgc__timer"
        hidden
        aria-live="polite"
      >
        <span class="skgc__timer-icon">
          ${clockIcon()}
        </span>

        <span class="skgc__timer-value"></span>
      </div>

      <footer class="skgc__footer">

        <div class="skgc__counter">
          <span class="skgc__counter-current">01</span>
          <span>/</span>
          <span class="skgc__counter-total">
            ${padNumber(guide.slides.length)}
          </span>
        </div>

        <div class="skgc__timeline"></div>

        <button
          class="skgc__pause"
          type="button"
          aria-label="Pause autoplay"
        >
          Pause
        </button>

      </footer>

    </div>

    ${
      attributionConfig.visible !== false &&
      attributionConfig.text
        ? `
          <div class="skgc__developed-note">
            ${escapeHtml(attributionConfig.text)}
          </div>
        `
        : ''
    }

    ${
      recipeGuideConfig.visible !== false
        ? `
          <section
            class="skgc__recipe-guide"
            aria-label="Step-by-step cooking guide"
          >
            <div class="skgc__recipe-guide-head">

              <div class="skgc__recipe-guide-eyebrow">
                ${escapeHtml(
                  recipeGuideConfig.eyebrow ||
                  guide.title ||
                  ''
                )}
              </div>

              <h2 class="skgc__recipe-guide-title">
                ${escapeHtml(
                  recipeGuideConfig.title ||
                  'Step-by-Step Cooking Guide'
                )}
              </h2>

              ${
                recipeGuideConfig.intro
                  ? `
                    <p class="skgc__recipe-guide-intro">
                      ${escapeHtml(recipeGuideConfig.intro)}
                    </p>
                  `
                  : ''
              }

            </div>

            <div class="skgc__accordion"></div>
          </section>
        `
        : ''
    }

    ${
      shareConfig.visible !== false ||
      shopConfig.visible !== false
        ? `
          <section class="skgc-footer">

            ${
              shareConfig.visible !== false
                ? `
                  <div class="skgc-share">

                    <h2>
                      ${escapeHtml(
                        shareConfig.title ||
                        'Share this Recipe'
                      )}
                    </h2>

                    ${
                      shareConfig.text
                        ? `
                          <p>
                            ${escapeHtml(shareConfig.text)}
                          </p>
                        `
                        : ''
                    }

                    <div class="skgc-share-buttons">

                      <button
                        type="button"
                        class="skgc-share-whatsapp"
                      >
                        ${escapeHtml(
                          shareConfig.whatsappLabel ||
                          'WhatsApp'
                        )}
                      </button>

                      <button
                        type="button"
                        class="skgc-share-email"
                      >
                        ${escapeHtml(
                          shareConfig.emailLabel ||
                          'Email'
                        )}
                      </button>

                      <button
                        type="button"
                        class="skgc-share-copy"
                      >
                        ${escapeHtml(
                          shareConfig.copyLabel ||
                          'Copy Link'
                        )}
                      </button>

                    </div>

                  </div>
                `
                : ''
            }

            ${
              shopConfig.visible !== false
                ? `
                  <div class="skgc-ingredients">

                    <div class="skgc-heading">

                      ${
                        shopConfig.eyebrow
                          ? `
                            <div class="skgc-eyebrow">
                              ${escapeHtml(shopConfig.eyebrow)}
                            </div>
                          `
                          : ''
                      }

                      <h2>
                        ${escapeHtml(
                          shopConfig.title ||
                          'Shop the Ingredients'
                        )}
                      </h2>

                      ${
                        shopConfig.text
                          ? `
                            <p>
                              ${escapeHtml(shopConfig.text)}
                            </p>
                          `
                          : ''
                      }

                    </div>

                    <div
                      class="skgc-products"
                      data-skgc-products
                    ></div>

                    <div
                      class="skgc-products-loading"
                      data-skgc-products-loading
                    >
                      Loading ingredients…
                    </div>

                    <div
                      class="skgc-view-all"
                      data-skgc-view-all
                      hidden
                    >
                      <a href="#">
                        ${escapeHtml(
                          shopConfig.viewAllLabel ||
                          'View Full Collection'
                        )}
                      </a>
                    </div>

                  </div>
                `
                : ''
            }

          </section>
        `
        : ''
    }

    <div
      class="skgc-quick-view"
      data-skgc-quick-view-modal
      hidden
    >

      <div
        class="skgc-quick-view__backdrop"
        data-skgc-quick-view-close
      ></div>

      <div
        class="skgc-quick-view__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="skgc-quick-view-title"
      >

        <button
          type="button"
          class="skgc-quick-view__close"
          data-skgc-quick-view-close
          aria-label="Close product details"
        >
          ×
        </button>

        <div class="skgc-quick-view__media">

          <img
            class="skgc-quick-view__image"
            data-skgc-quick-view-image
            src=""
            alt=""
          >

        </div>

        <div class="skgc-quick-view__content">

          <div class="skgc-quick-view__eyebrow">
            La despensa · Spanish Kitchen
          </div>

          <h3
            id="skgc-quick-view-title"
            class="skgc-quick-view__title"
            data-skgc-quick-view-title
          ></h3>

          <div
            class="skgc-quick-view__price"
            data-skgc-quick-view-price
          ></div>

          <p
            class="skgc-quick-view__description"
            data-skgc-quick-view-description
          ></p>

          <div class="skgc-quick-view__quantity">

            <span class="skgc-quick-view__quantity-label">
              Quantity
            </span>

            <div class="skgc-quick-view__quantity-control">

              <button
                type="button"
                data-skgc-qty-minus
                aria-label="Decrease quantity"
              >
                −
              </button>

              <input
                type="number"
                min="1"
                value="1"
                inputmode="numeric"
                data-skgc-qty-input
                aria-label="Quantity"
              >

              <button
                type="button"
                data-skgc-qty-plus
                aria-label="Increase quantity"
              >
                +
              </button>

            </div>

          </div>

          <button
            type="button"
            class="skgc-quick-view__add"
            data-skgc-quick-view-add
          >
            Add to cart
          </button>

          <a
            class="skgc-quick-view__product-link"
            data-skgc-quick-view-link
            href="#"
          >
            View full product
          </a>

        </div>

      </div>

    </div>

  `;

  /* ========================================================
     REFERENCES
  ======================================================== */

  const shell =
    root.querySelector('.skgc__shell');

  const stage =
    root.querySelector('.skgc__stage');

  const prevButton =
    root.querySelector('.skgc__nav--prev');

  const nextButton =
    root.querySelector('.skgc__nav--next');

  const modeButton =
    root.querySelector('.skgc__mode');

  const pauseButton =
    root.querySelector('.skgc__pause');

  const currentCounter =
    root.querySelector('.skgc__counter-current');

  const timeline =
    root.querySelector('.skgc__timeline');

  const timerElement =
    root.querySelector('.skgc__timer');

  const timerValue =
    root.querySelector('.skgc__timer-value');

  const accordion =
    root.querySelector('.skgc__accordion');

  const shareWhatsappButton =
    root.querySelector('.skgc-share-whatsapp');

  const shareEmailButton =
    root.querySelector('.skgc-share-email');

  const shareCopyButton =
    root.querySelector('.skgc-share-copy');

  const productsContainer =
    root.querySelector('[data-skgc-products]');

  const productsLoading =
    root.querySelector('[data-skgc-products-loading]');

  const viewAllContainer =
    root.querySelector('[data-skgc-view-all]');

  const quickViewModal =
    root.querySelector('[data-skgc-quick-view-modal]');

  const quickViewImage =
    root.querySelector('[data-skgc-quick-view-image]');

  const quickViewTitle =
    root.querySelector('[data-skgc-quick-view-title]');

  const quickViewPrice =
    root.querySelector('[data-skgc-quick-view-price]');

  const quickViewDescription =
    root.querySelector('[data-skgc-quick-view-description]');

  const quickViewLink =
    root.querySelector('[data-skgc-quick-view-link]');

  const quickViewAdd =
    root.querySelector('[data-skgc-quick-view-add]');

  const quickViewQtyInput =
    root.querySelector('[data-skgc-qty-input]');

  const quickViewQtyMinus =
    root.querySelector('[data-skgc-qty-minus]');

  const quickViewQtyPlus =
    root.querySelector('[data-skgc-qty-plus]');

  /* ========================================================
     BUILD SLIDES
  ======================================================== */

  guide.slides.forEach(function (slide, index) {

    const image =
      getSlideImage(slide);

    const content =
      slide.content || {};

    const slideElement =
      document.createElement('article');

    slideElement.className =
      'skgc__slide';

    slideElement.dataset.index =
      index;

    slideElement.innerHTML = `

      <picture class="skgc__picture">

        ${
          image.mobile
            ? `
              <source
                media="(max-width: ${settings.mobileBreakpoint}px)"
                srcset="${escapeHtml(image.mobile)}"
              >
            `
            : ''
        }

        <img
          class="skgc__image"
          src="${escapeHtml(image.desktop)}"
          alt="${escapeHtml(image.alt)}"
          loading="${index < 2 ? 'eager' : 'lazy'}"
          decoding="async"
        >

      </picture>

      <div class="skgc__shade"></div>

      <div class="skgc__content">

        ${
          content.eyebrow
            ? `
              <div class="skgc__eyebrow">
                ${escapeHtml(content.eyebrow)}
              </div>
            `
            : ''
        }

        ${
          content.kicker
            ? `
              <div class="skgc__kicker">
                ${escapeHtml(content.kicker)}
              </div>
            `
            : ''
        }

        ${
          content.title
            ? `
              <h2 class="skgc__title">
                ${escapeHtml(content.title)}
              </h2>
            `
            : ''
        }

        ${
          content.subtitle
            ? `
              <p class="skgc__subtitle">
                ${escapeHtml(content.subtitle)}
              </p>
            `
            : ''
        }

        ${
          content.text
            ? `
              <p class="skgc__text">
                ${escapeHtml(content.text)}
              </p>
            `
            : ''
        }

        ${
          content.note
            ? `
              <div class="skgc__note">
                ${escapeHtml(content.note)}
              </div>
            `
            : ''
        }

      </div>

    `;

    stage.appendChild(
      slideElement
    );

    const tick =
      document.createElement('button');

    tick.type =
      'button';

    tick.className =
      'skgc__tick';

    tick.setAttribute(
      'aria-label',
      'Go to slide ' +
      (index + 1)
    );

    tick.innerHTML =
      '<span></span>';

    tick.addEventListener(
      'click',
      function () {

        manualNavigation(
          index
        );

      }
    );

    timeline.appendChild(
      tick
    );
  });

  const slideElements =
    Array.from(
      root.querySelectorAll(
        '.skgc__slide'
      )
    );

  const tickElements =
    Array.from(
      root.querySelectorAll(
        '.skgc__tick'
      )
    );

  /* ========================================================
     TIMER
  ======================================================== */

  function renderTimer(slide) {

    if (
      !slide ||
      slide.timer === false ||
      slide.timer === null ||
      slide.timer === undefined ||
      slide.timer === ''
    ) {

      timerElement.hidden =
        true;

      timerValue.textContent =
        '';

      return;
    }

    timerValue.textContent =
      String(
        slide.timer
      );

    timerElement.hidden =
      false;
  }

  /* ========================================================
     SHOW SLIDE
  ======================================================== */

  function showSlide(
    index,
    options
  ) {

    options =
      options || {};

    if (index < 0) {

      index =
        settings.loop
          ? guide.slides.length - 1
          : 0;
    }

    if (
      index >=
      guide.slides.length
    ) {

      index =
        settings.loop
          ? 0
          : guide.slides.length - 1;
    }

    currentIndex =
      index;

    slideElements.forEach(
      function (
        slideElement,
        i
      ) {

        slideElement.classList.toggle(
          'is-active',
          i === currentIndex
        );

        if (
          options.instant &&
          i === currentIndex
        ) {

          slideElement.classList.add(
            'is-instant'
          );

          requestAnimationFrame(
            function () {

              slideElement.classList.remove(
                'is-instant'
              );

            }
          );
        }
      }
    );

    tickElements.forEach(
      function (
        tick,
        i
      ) {

        tick.classList.toggle(
          'is-active',
          i <= currentIndex
        );

      }
    );

    currentCounter.textContent =
      padNumber(
        currentIndex + 1
      );

    renderTimer(
      guide.slides[
        currentIndex
      ]
    );

    if (
      settings.autoplay &&
      !isPaused &&
      !options.skipAutoplay
    ) {

      startAutoplay();
    }
  }

  function nextSlide() {

    showSlide(
      currentIndex + 1
    );
  }

  /* ========================================================
     AUTOPLAY
  ======================================================== */

  function clearAutoplay() {

    if (
      autoplayTimer
    ) {

      clearTimeout(
        autoplayTimer
      );

      autoplayTimer =
        null;
    }
  }

  function clearResumeTimer() {

    if (
      resumeTimer
    ) {

      clearTimeout(
        resumeTimer
      );

      resumeTimer =
        null;
    }
  }

  function startAutoplay() {

    clearAutoplay();

    if (
      !settings.autoplay ||
      isPaused
    ) {
      return;
    }

    autoplayTimer =
      window.setTimeout(
        function () {

          nextSlide();

        },
        settings.autoplayDelay
      );
  }

  function scheduleAutoplayResume() {

    if (
      !settings.autoplay ||
      isPaused
    ) {
      return;
    }

    clearAutoplay();
    clearResumeTimer();

    resumeTimer =
      window.setTimeout(
        function () {

          startAutoplay();

        },
        settings.resumeDelay
      );
  }

  function manualNavigation(
    index
  ) {

    clearAutoplay();
    clearResumeTimer();

    showSlide(
      index,
      {
        skipAutoplay: true
      }
    );

    scheduleAutoplayResume();
  }

  /* ========================================================
     PAUSE
  ======================================================== */

  function setPaused(
    paused
  ) {

    isPaused =
      paused;

    if (
      isPaused
    ) {

      clearAutoplay();
      clearResumeTimer();

      pauseButton.textContent =
        'Play';

      pauseButton.setAttribute(
        'aria-label',
        'Resume autoplay'
      );

    } else {

      pauseButton.textContent =
        'Pause';

      pauseButton.setAttribute(
        'aria-label',
        'Pause autoplay'
      );

      startAutoplay();
    }
  }

  /* ========================================================
     CLEAN MODE
  ======================================================== */

  function setCleanMode(
    enabled
  ) {

    cleanMode =
      enabled;

    shell.classList.toggle(
      'skgc--clean',
      cleanMode
    );

    modeButton.textContent =
      cleanMode
        ? 'Show guide'
        : 'View image';

    modeButton.setAttribute(
      'aria-label',
      cleanMode
        ? 'Show guide text'
        : 'Hide text and view image'
    );
  }

  /* ========================================================
     ACCORDION
  ======================================================== */

  function buildAccordion() {

    if (
      !accordion
    ) {
      return;
    }

    const chapterOrder = [
      'Ingredients',
      'Building the flavour',
      'Prepare for the rice',
      'Get the flavour into the rice',
      'The final touch',
      'Enjoy the moment'
    ];

    const chapters =
      {};

    chapterOrder.forEach(
      function (
        chapter
      ) {

        chapters[
          chapter
        ] = [];
      }
    );

    guide.slides.forEach(
      function (
        slide
      ) {

        if (
          !slide.chapter
        ) {
          return;
        }

        if (
          !chapters[
            slide.chapter
          ]
        ) {

          chapters[
            slide.chapter
          ] = [];
        }

        chapters[
          slide.chapter
        ].push(
          slide
        );
      }
    );

    chapterOrder.forEach(
      function (
        chapterName,
        chapterIndex
      ) {

        const chapterSlides =
          chapters[
            chapterName
          ];

        if (
          !chapterSlides ||
          !chapterSlides.length
        ) {
          return;
        }

        const item =
          document.createElement(
            'div'
          );

        item.className =
          'skgc__accordion-item';

        const trigger =
          document.createElement(
            'button'
          );

        trigger.type =
          'button';

        trigger.className =
          'skgc__accordion-trigger';

        trigger.setAttribute(
          'aria-expanded',
          'false'
        );

        trigger.innerHTML = `

          <span
            class="skgc__accordion-number"
          >
            ${padNumber(
              chapterIndex + 1
            )}
          </span>

          <span
            class="skgc__accordion-label"
          >
            ${escapeHtml(
              chapterName
            )}
          </span>

          <span
            class="skgc__accordion-plus"
            aria-hidden="true"
          >
            +
          </span>

        `;

        const panel =
          document.createElement(
            'div'
          );

        panel.className =
          'skgc__accordion-panel';

        panel.hidden =
          true;

        const inner =
          document.createElement(
            'div'
          );

        inner.className =
          'skgc__accordion-inner';

        if (
          chapterName ===
          'Ingredients'
        ) {

          const imageSlide =
            chapterSlides.find(
              function (
                slide
              ) {

                return (
                  slide.accordionImage ===
                  true
                );
              }
            );

          if (
            imageSlide &&
            imageSlide.image
          ) {

            inner.innerHTML = `

              <div
                class="skgc__ingredients-wrap"
              >

                <picture
                  class="skgc__ingredients-table"
                >

                  ${
                    imageSlide.image.mobile

                      ? `
                        <source
                          media="(max-width: ${settings.mobileBreakpoint}px)"
                          srcset="${escapeHtml(
                            imageSlide.image.mobile
                          )}"
                        >
                      `

                      : ''
                  }

                  <img
                    src="${escapeHtml(
                      imageSlide.image.desktop
                    )}"
                    alt="${escapeHtml(
                      imageSlide.image.alt ||
                      'Ingredients'
                    )}"
                    loading="lazy"
                  >

                </picture>

              </div>

            `;
          }

        } else {

          let stepNumber =
            0;

          chapterSlides.forEach(
            function (
              slide
            ) {

              if (
                slide.accordionExclude ===
                true
              ) {
                return;
              }

              stepNumber +=
                1;

              const content =
                slide.content || {};

              const step =
                document.createElement(
                  'article'
                );

              step.className =
                'skgc__recipe-step';

              let timerMarkup =
                '';

              if (
                slide.timer
              ) {

                timerMarkup = `

                  <span
                    class="skgc__recipe-step-time"
                  >

                    <span
                      class="skgc__recipe-step-clock"
                    >
                      ${clockIcon()}
                    </span>

                    ${escapeHtml(
                      slide.timer
                    )}

                  </span>

                `;
              }

              step.innerHTML = `

                <div
                  class="skgc__recipe-step-head"
                >

                  <span
                    class="skgc__recipe-step-index"
                  >
                    ${padNumber(
                      stepNumber
                    )}
                  </span>

                  <h3
                    class="skgc__recipe-step-title"
                  >
                    ${escapeHtml(
                      content.title ||
                      ''
                    )}
                  </h3>

                  ${timerMarkup}

                </div>

                ${
                  content.text

                    ? `
                      <p
                        class="skgc__recipe-step-text"
                      >
                        ${escapeHtml(
                          content.text
                        )}
                      </p>
                    `

                    : ''
                }

                ${
                  content.note

                    ? `
                      <p
                        class="skgc__recipe-step-note"
                      >
                        ${escapeHtml(
                          content.note
                        )}
                      </p>
                    `

                    : ''
                }

              `;

              inner.appendChild(
                step
              );
            }
          );
        }

        panel.appendChild(
          inner
        );

        item.appendChild(
          trigger
        );

        item.appendChild(
          panel
        );

        accordion.appendChild(
          item
        );

        trigger.addEventListener(
          'click',
          function () {

            const isOpen =
              item.classList.contains(
                'is-open'
              );

            accordion
              .querySelectorAll(
                '.skgc__accordion-item.is-open'
              )
              .forEach(
                function (
                  openItem
                ) {

                  if (
                    openItem ===
                    item
                  ) {
                    return;
                  }

                  openItem.classList.remove(
                    'is-open'
                  );

                  const openPanel =
                    openItem.querySelector(
                      '.skgc__accordion-panel'
                    );

                  const openTrigger =
                    openItem.querySelector(
                      '.skgc__accordion-trigger'
                    );

                  if (
                    openPanel
                  ) {
                    openPanel.hidden =
                      true;
                  }

                  if (
                    openTrigger
                  ) {
                    openTrigger.setAttribute(
                      'aria-expanded',
                      'false'
                    );
                  }
                }
              );

            if (
              isOpen
            ) {

              item.classList.remove(
                'is-open'
              );

              panel.hidden =
                true;

              trigger.setAttribute(
                'aria-expanded',
                'false'
              );

            } else {

              item.classList.add(
                'is-open'
              );

              panel.hidden =
                false;

              trigger.setAttribute(
                'aria-expanded',
                'true'
              );
            }
          }
        );
      }
    );
  }

  /* ========================================================
     SHARE
  ======================================================== */

  function getShareData() {

    const title =
      guide.title ||
      document.title;

    const url =
      window.location.href
        .split('#')[0];

    return {
      title: title,
      url: url,
      message:
        title +
        ' — ' +
        url
    };
  }

  function copyText(
    text
  ) {

    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText ===
        'function' &&
      window.isSecureContext
    ) {

      return navigator.clipboard.writeText(
        text
      );
    }

    return new Promise(
      function (
        resolve,
        reject
      ) {

        const textarea =
          document.createElement(
            'textarea'
          );

        textarea.value =
          text;

        textarea.setAttribute(
          'readonly',
          ''
        );

        textarea.style.position =
          'fixed';

        textarea.style.left =
          '-9999px';

        textarea.style.top =
          '-9999px';

        textarea.style.opacity =
          '0';

        document.body.appendChild(
          textarea
        );

        textarea.focus();
        textarea.select();

        try {

          const successful =
            document.execCommand(
              'copy'
            );

          document.body.removeChild(
            textarea
          );

          if (
            successful
          ) {

            resolve();

          } else {

            reject(
              new Error(
                'Copy command failed'
              )
            );
          }

        } catch (
          error
        ) {

          document.body.removeChild(
            textarea
          );

          reject(
            error
          );
        }
      }
    );
  }

  function initialiseShare() {

    if (
      shareWhatsappButton
    ) {

      shareWhatsappButton.addEventListener(
        'click',
        function () {

          const share =
            getShareData();

          window.open(
            'https://wa.me/?text=' +
            encodeURIComponent(
              share.message
            ),
            '_blank',
            'noopener,noreferrer'
          );
        }
      );
    }

    if (
      shareEmailButton
    ) {

      shareEmailButton.addEventListener(
        'click',
        function () {

          const share =
            getShareData();

          window.location.href =
            'mailto:?subject=' +
            encodeURIComponent(
              share.title
            ) +
            '&body=' +
            encodeURIComponent(
              share.message
            );
        }
      );
    }

    if (
      shareCopyButton
    ) {

      const original =
        shareCopyButton
          .textContent
          .trim() ||
        'Copy Link';

      shareCopyButton.addEventListener(
        'click',
        function () {

          const share =
            getShareData();

          copyText(
            share.url
          )
            .then(
              function () {

                setTemporaryButtonText(
                  shareCopyButton,
                  'Link Copied',
                  original,
                  2000
                );
              }
            )
            .catch(
              function () {

                setTemporaryButtonText(
                  shareCopyButton,
                  'Unable to Copy',
                  original,
                  2000
                );
              }
            );
        }
      );
    }
  }

  /* ========================================================
     CART
  ======================================================== */

  async function addToCart(
    variantId,
    quantity
  ) {

    const id =
      parseInt(
        variantId,
        10
      );

    const qty =
      Math.max(
        1,
        parseInt(
          quantity,
          10
        ) || 1
      );

    if (
      !id
    ) {

      throw new Error(
        'Missing variant ID'
      );
    }

    const response =
      await fetch(
        getShopRoot() +
        'cart/add.js',
        {
          method: 'POST',
          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify(
              {
                items: [
                  {
                    id: id,
                    quantity: qty
                  }
                ]
              }
            )
        }
      );

    if (
      !response.ok
    ) {

      const errorData =
        await response
          .json()
          .catch(
            function () {
              return {};
            }
          );

      throw new Error(
        errorData.description ||
        errorData.message ||
        'Unable to add product to cart'
      );
    }

    const result =
      await response.json();

    document.dispatchEvent(
      new CustomEvent(
        'skgc:cart:add',
        {
          detail:
            result
        }
      )
    );

    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          detail:
            result
        }
      )
    );

    return result;
  }

  function bindDirectAddToCart(
    scope
  ) {

    const container =
      scope ||
      root;

    container
      .querySelectorAll(
        '[data-skgc-add-to-cart]'
      )
      .forEach(
        function (
          button
        ) {

          if (
            button.dataset.skgcBound ===
            'true'
          ) {
            return;
          }

          button.dataset.skgcBound =
            'true';

          button.addEventListener(
            'click',
            async function (
              event
            ) {

              event.preventDefault();
              event.stopPropagation();

              const variantId =
                button.dataset.variantId;

              const original =
                button.textContent.trim() ||
                'Add to cart';

              button.disabled =
                true;

              button.classList.add(
                'is-loading'
              );

              button.textContent =
                'Adding…';

              try {

                await addToCart(
                  variantId,
                  1
                );

                button.classList.remove(
                  'is-loading'
                );

                button.classList.add(
                  'is-added'
                );

                button.textContent =
                  'Added ✓';

                window.setTimeout(
                  function () {

                    button.classList.remove(
                      'is-added'
                    );

                    button.textContent =
                      original;

                    button.disabled =
                      false;

                  },
                  1800
                );

              } catch (
                error
              ) {

                console.warn(
                  'Spanish Kitchen Guide: unable to add product.',
                  error
                );

                button.classList.remove(
                  'is-loading'
                );

                button.textContent =
                  'Try again';

                window.setTimeout(
                  function () {

                    button.textContent =
                      original;

                    button.disabled =
                      false;

                  },
                  1800
                );
              }
            }
          );
        }
      );
  }

  /* ========================================================
     QUICK VIEW
  ======================================================== */

  function openQuickView(
    item
  ) {

    if (
      !quickViewModal
    ) {
      return;
    }

    const data =
      getItemData(
        item
      );

    if (
      !data
    ) {
      return;
    }

    lastFocusedElement =
      document.activeElement;

    quickViewModal.dataset.variantId =
      data.variantId ||
      '';

    quickViewModal.dataset.available =
      data.available
        ? 'true'
        : 'false';

    if (
      quickViewImage
    ) {

      quickViewImage.src =
        data.image ||
        '';

      quickViewImage.alt =
        data.title ||
        '';

      quickViewImage.hidden =
        !data.image;
    }

    if (
      quickViewTitle
    ) {

      quickViewTitle.textContent =
        data.title ||
        '';
    }

    if (
      quickViewPrice
    ) {

      if (
        data.comparePriceFormatted &&
        data.comparePrice &&
        parseInt(
          data.comparePrice,
          10
        ) >
        parseInt(
          data.price ||
          '0',
          10
        )
      ) {

        quickViewPrice.innerHTML = `

          <span
            class="skgc-quick-view__current-price"
          >
            ${escapeHtml(
              data.priceFormatted
            )}
          </span>

          <span
            class="skgc-quick-view__compare-price"
          >
            ${escapeHtml(
              data.comparePriceFormatted
            )}
          </span>

        `;

      } else {

        quickViewPrice.innerHTML = `

          <span
            class="skgc-quick-view__current-price"
          >
            ${escapeHtml(
              data.priceFormatted
            )}
          </span>

        `;
      }
    }

    if (
      quickViewDescription
    ) {

      quickViewDescription.textContent =
        data.description ||
        '';

      quickViewDescription.hidden =
        !data.description;
    }

    if (
      quickViewLink
    ) {

      quickViewLink.href =
        data.url ||
        '#';
    }

    if (
      quickViewQtyInput
    ) {

      quickViewQtyInput.value =
        '1';
    }

    if (
      quickViewAdd
    ) {

      quickViewAdd.disabled =
        !data.available ||
        !data.variantId;

      quickViewAdd.textContent =
        data.available
          ? 'Add to cart'
          : 'Sold out';

      quickViewAdd.classList.remove(
        'is-added',
        'is-loading'
      );
    }

    quickViewModal.hidden =
      false;

    document.documentElement.classList.add(
      'skgc-modal-open'
    );

    document.body.classList.add(
      'skgc-modal-open'
    );

    const closeButton =
      quickViewModal.querySelector(
        '.skgc-quick-view__close'
      );

    if (
      closeButton
    ) {

      window.setTimeout(
        function () {

          closeButton.focus();

        },
        0
      );
    }
  }

  function closeQuickView() {

    if (
      !quickViewModal ||
      quickViewModal.hidden
    ) {
      return;
    }

    quickViewModal.hidden =
      true;

    quickViewModal.dataset.variantId =
      '';

    quickViewModal.dataset.available =
      '';

    document.documentElement.classList.remove(
      'skgc-modal-open'
    );

    document.body.classList.remove(
      'skgc-modal-open'
    );

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus ===
        'function'
    ) {

      lastFocusedElement.focus();
    }
  }

  function bindQuickViewButtons(
    scope
  ) {

    const container =
      scope ||
      root;

    container
      .querySelectorAll(
        '[data-skgc-quick-view]'
      )
      .forEach(
        function (
          button
        ) {

          if (
            button.dataset.skgcBound ===
            'true'
          ) {
            return;
          }

          button.dataset.skgcBound =
            'true';

          button.addEventListener(
            'click',
            function (
              event
            ) {

              event.preventDefault();
              event.stopPropagation();

              const item =
                button.closest(
                  '.skgc-product-bridge-item'
                );

              openQuickView(
                item
              );
            }
          );
        }
      );
  }

  function initialiseQuickView() {

    if (
      !quickViewModal
    ) {
      return;
    }

    quickViewModal
      .querySelectorAll(
        '[data-skgc-quick-view-close]'
      )
      .forEach(
        function (
          button
        ) {

          button.addEventListener(
            'click',
            function () {

              closeQuickView();
            }
          );
        }
      );

    if (
      quickViewQtyMinus &&
      quickViewQtyInput
    ) {

      quickViewQtyMinus.addEventListener(
        'click',
        function () {

          const current =
            Math.max(
              1,
              parseInt(
                quickViewQtyInput.value,
                10
              ) || 1
            );

          quickViewQtyInput.value =
            String(
              Math.max(
                1,
                current - 1
              )
            );
        }
      );
    }

    if (
      quickViewQtyPlus &&
      quickViewQtyInput
    ) {

      quickViewQtyPlus.addEventListener(
        'click',
        function () {

          const current =
            Math.max(
              1,
              parseInt(
                quickViewQtyInput.value,
                10
              ) || 1
            );

          quickViewQtyInput.value =
            String(
              current + 1
            );
        }
      );
    }

    if (
      quickViewQtyInput
    ) {

      quickViewQtyInput.addEventListener(
        'change',
        function () {

          const current =
            Math.max(
              1,
              parseInt(
                quickViewQtyInput.value,
                10
              ) || 1
            );

          quickViewQtyInput.value =
            String(
              current
            );
        }
      );
    }

    if (
      quickViewAdd
    ) {

      quickViewAdd.addEventListener(
        'click',
        async function () {

          const variantId =
            quickViewModal.dataset.variantId;

          const quantity =
            quickViewQtyInput
              ? quickViewQtyInput.value
              : 1;

          const original =
            'Add to cart';

          if (
            !variantId ||
            quickViewModal.dataset.available !==
              'true'
          ) {
            return;
          }

          quickViewAdd.disabled =
            true;

          quickViewAdd.classList.add(
            'is-loading'
          );

          quickViewAdd.textContent =
            'Adding…';

          try {

            await addToCart(
              variantId,
              quantity
            );

            quickViewAdd.classList.remove(
              'is-loading'
            );

            quickViewAdd.classList.add(
              'is-added'
            );

            quickViewAdd.textContent =
              'Added ✓';

            window.setTimeout(
              function () {

                quickViewAdd.classList.remove(
                  'is-added'
                );

                quickViewAdd.textContent =
                  original;

                quickViewAdd.disabled =
                  false;

              },
              1800
            );

          } catch (
            error
          ) {

            console.warn(
              'Spanish Kitchen Guide: unable to add product.',
              error
            );

            quickViewAdd.classList.remove(
              'is-loading'
            );

            quickViewAdd.textContent =
              'Try again';

            window.setTimeout(
              function () {

                quickViewAdd.textContent =
                  original;

                quickViewAdd.disabled =
                  false;

              },
              1800
            );
          }
        }
      );
    }

    document.addEventListener(
      'keydown',
      function (
        event
      ) {

        if (
          event.key ===
            'Escape' &&
          !quickViewModal.hidden
        ) {

          closeQuickView();
        }
      }
    );
  }

  /* ========================================================
     SHOP PRODUCTS
  ======================================================== */

  function buildProductGroups(
    items
  ) {

    if (
      !productsContainer
    ) {
      return;
    }

    productsContainer.innerHTML =
      '';

    const groups =
      Array.isArray(
        shopConfig.groups
      )
        ? shopConfig.groups
        : [];

    if (
      !groups.length
    ) {

      items.forEach(
        function (
          item
        ) {

          productsContainer.appendChild(
            item.cloneNode(
              true
            )
          );
        }
      );

      bindDirectAddToCart(
        productsContainer
      );

      bindQuickViewButtons(
        productsContainer
      );

      return;
    }

    groups.forEach(
      function (
        group,
        groupIndex
      ) {

        const groupItems =
          items.filter(
            function (
              item
            ) {

              return (
                item.dataset.skgcGroup ||
                ''
              ) ===
              String(
                group.value ||
                ''
              );
            }
          );

        if (
          !groupItems.length
        ) {
          return;
        }

        const section =
          document.createElement(
            'section'
          );

        section.className =
          'skgc-shop-group';

        section.dataset.skgcShopGroup =
          group.key ||
          group.value ||
          '';

        section.innerHTML = `

          <div
            class="skgc-shop-group__head"
          >

            <div
              class="skgc-shop-group__number"
            >
              ${escapeHtml(
                group.number ||
                padNumber(
                  groupIndex + 1
                )
              )}
            </div>

            <div
              class="skgc-shop-group__heading"
            >

              <h3
                class="skgc-shop-group__title"
              >
                ${escapeHtml(
                  group.title ||
                  ''
                )}
              </h3>

              ${
                group.text

                  ? `
                    <p
                      class="skgc-shop-group__text"
                    >
                      ${escapeHtml(
                        group.text
                      )}
                    </p>
                  `

                  : ''
              }

            </div>

          </div>

          <div
            class="skgc-shop-group__products"
          ></div>

        `;

        const grid =
          section.querySelector(
            '.skgc-shop-group__products'
          );

        groupItems.forEach(
          function (
            item
          ) {

            grid.appendChild(
              item.cloneNode(
                true
              )
            );
          }
        );

        productsContainer.appendChild(
          section
        );
      }
    );

    const ungrouped =
      items.filter(
        function (
          item
        ) {

          const value =
            item.dataset.skgcGroup ||
            '';

          return !groups.some(
            function (
              group
            ) {

              return (
                String(
                  group.value ||
                  ''
                ) ===
                value
              );
            }
          );
        }
      );

    if (
      ungrouped.length
    ) {

      const section =
        document.createElement(
          'section'
        );

      section.className =
        'skgc-shop-group skgc-shop-group--other';

      section.innerHTML = `

        <div
          class="skgc-shop-group__head"
        >

          <div
            class="skgc-shop-group__number"
          >
            +
          </div>

          <div
            class="skgc-shop-group__heading"
          >

            <h3
              class="skgc-shop-group__title"
            >
              More Ingredients
            </h3>

          </div>

        </div>

        <div
          class="skgc-shop-group__products"
        ></div>

      `;

      const grid =
        section.querySelector(
          '.skgc-shop-group__products'
        );

      ungrouped.forEach(
        function (
          item
        ) {

          grid.appendChild(
            item.cloneNode(
              true
            )
          );
        }
      );

      productsContainer.appendChild(
        section
      );
    }

    bindDirectAddToCart(
      productsContainer
    );

    bindQuickViewButtons(
      productsContainer
    );
  }

  async function loadShopProducts() {

    if (
      !productsContainer ||
      shopConfig.visible ===
        false ||
      !shopConfig.collectionHandle
    ) {
      return;
    }

    const handle =
      String(
        shopConfig.collectionHandle
      ).trim();

    const limit =
      Math.max(
        1,
        parseInt(
          shopConfig.limit,
          10
        ) || 50
      );

    const shopRoot =
      getShopRoot();

    const collectionUrl =
      shopRoot +
      'collections/' +
      encodeURIComponent(
        handle
      );

    const sectionUrl =
      collectionUrl +
      '?section_id=skgc-products-bridge';

    try {

      const response =
        await fetch(
          sectionUrl,
          {
            credentials:
              'same-origin'
          }
        );

      if (
        !response.ok
      ) {

        throw new Error(
          'Collection request failed'
        );
      }

      const html =
        await response.text();

      const parser =
        new DOMParser();

      const doc =
        parser.parseFromString(
          html,
          'text/html'
        );

      let items =
        Array.from(
          doc.querySelectorAll(
            '.skgc-product-bridge-item'
          )
        );

      items =
        items.slice(
          0,
          limit
        );

      if (
        !items.length
      ) {

        productsContainer.innerHTML =
          '<div class="skgc-empty">Products coming soon.</div>';

      } else {

        buildProductGroups(
          items
        );
      }

      if (
        productsLoading
      ) {

        productsLoading.hidden =
          true;
      }

      if (
        viewAllContainer
      ) {

        const link =
          viewAllContainer.querySelector(
            'a'
          );

        if (
          link
        ) {

          link.href =
            collectionUrl;
        }

        viewAllContainer.hidden =
          false;
      }

    } catch (
      error
    ) {

      console.warn(
        'Spanish Kitchen Guide: unable to load products.',
        error
      );

      if (
        productsLoading
      ) {

        productsLoading.hidden =
          true;
      }

      productsContainer.innerHTML =
        '<div class="skgc-empty">Ingredients are temporarily unavailable.</div>';
    }
  }

  /* ========================================================
     EVENTS
  ======================================================== */

  prevButton.addEventListener(
    'click',
    function () {

      manualNavigation(
        currentIndex - 1
      );
    }
  );

  nextButton.addEventListener(
    'click',
    function () {

      manualNavigation(
        currentIndex + 1
      );
    }
  );

  pauseButton.addEventListener(
    'click',
    function () {

      setPaused(
        !isPaused
      );
    }
  );

  modeButton.addEventListener(
    'click',
    function () {

      setCleanMode(
        !cleanMode
      );
    }
  );

  root.addEventListener(
    'keydown',
    function (
      event
    ) {

      const target =
        event.target;

      if (
        target &&
        target.tagName ===
          'BUTTON'
      ) {
        return;
      }

      if (
        event.key ===
        'ArrowLeft'
      ) {

        manualNavigation(
          currentIndex - 1
        );
      }

      if (
        event.key ===
        'ArrowRight'
      ) {

        manualNavigation(
          currentIndex + 1
        );
      }

      if (
        event.key ===
        ' '
      ) {

        event.preventDefault();

        setPaused(
          !isPaused
        );
      }
    }
  );

  root.setAttribute(
    'tabindex',
    '0'
  );

  document.addEventListener(
    'visibilitychange',
    function () {

      if (
        document.hidden
      ) {

        clearAutoplay();
        clearResumeTimer();

      } else if (
        !isPaused
      ) {

        startAutoplay();
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function () {

      clearAutoplay();
      clearResumeTimer();
      closeQuickView();
    }
  );

  /* ========================================================
     START
  ======================================================== */

  buildAccordion();

  initialiseShare();

  initialiseQuickView();

  loadShopProducts();

  showSlide(
    0,
    {
      instant: true,
      skipAutoplay: true
    }
  );

  if (
    settings.autoplay
  ) {

    startAutoplay();
  }

})();
